import React from 'react';
import './styles.scss';
import { Modal } from './../../app/common/sharedComponents/Modal';
import { Disconected } from './../../app/common/icons/Disconected';
import {
  IconContainer,
  OfflineTitle,
  ButtonContainer,
  ModalContainer,
} from './NoInternet.styled';
import { Body5 } from './../../app/common/typography';
import { ButtonRetry } from './../../app/common/sharedComponents/ButtonRetry';
import { useTranslation } from 'react-i18next';

const NoInternet = ({ onRetryClick }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={true}>
      <ModalContainer>
        <IconContainer>
          <Disconected />
        </IconContainer>
        <OfflineTitle>{t('COMMON.LOGIN.OFFLINE.TITLE')}</OfflineTitle>
        <Body5 color="eerieBlack">
          {t('COMMON.LOGIN.OFFLINE.PLEASE_CONNECT_TO_INTERNET')}
        </Body5>
        <ButtonContainer>
          <ButtonRetry title="Retry" onClick={onRetryClick} />
        </ButtonContainer>
      </ModalContainer>
    </Modal>
  );
};

export default NoInternet;
